module.exports = __webpack_public_path__ + "static/media/back-right-svgrepo-com.cffdf222.svg";